import { AdditionalLoads, ComponentDesign } from '@paragon/contract-library';
import {
  AdditionalLoadsSchema,
  ComponentDesignSchema,
  GenericLoader,
  LoadCaseSchema,
  ModelChildLoader,
} from '@paragon/layout-models';

import {
  CustomFeaturePatternTrussDesignSchema,
  CustomProfileTrussDesignSchema,
} from '../schemas/CustomTrussDesignSchema';

function getAdditionalLoads(componentDesign: ComponentDesign): AdditionalLoads & { id: string } {
  return Object.assign({}, { id: 'additionalLoads' }, componentDesign.additionalLoads);
}

export function registerTrussLoadingSpecificComponentDesignDataLoaders(
  loaders: ModelChildLoader,
  loadCaseLoader: GenericLoader,
) {
  loaders.add(ComponentDesignSchema, LoadCaseSchema, loadCaseLoader);
  loaders.add(CustomFeaturePatternTrussDesignSchema, LoadCaseSchema, loadCaseLoader);
  loaders.add(CustomProfileTrussDesignSchema, LoadCaseSchema, loadCaseLoader);

  loaders.add(CustomFeaturePatternTrussDesignSchema, AdditionalLoadsSchema, getAdditionalLoads);
  loaders.add(CustomProfileTrussDesignSchema, AdditionalLoadsSchema, getAdditionalLoads);
}
